/** Display-only convenience — never used for auth decisions. */

const LS_KEY = 'maestro_remembered_login_email';

export function getRememberedLoginEmail(): string {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return '';
    const trimmed = raw.trim();
    return trimmed.includes('@') ? trimmed : '';
  } catch {
    return '';
  }
}

export function setRememberedLoginEmail(email: string): void {
  try {
    const trimmed = String(email || '').trim();
    if (!trimmed || !trimmed.includes('@')) return;
    localStorage.setItem(LS_KEY, trimmed);
  } catch {
    /* ignore */
  }
}

export function clearRememberedLoginEmail(): void {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}
